import { render } from "./SolutionsSection.vue?vue&type=template&id=67621fcc&scoped=true"
import script from "./SolutionsSection.vue?vue&type=script&lang=js"
export * from "./SolutionsSection.vue?vue&type=script&lang=js"

import "./SolutionsSection.vue?vue&type=style&index=0&id=67621fcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67621fcc"]])

export default __exports__